import React, { Component } from 'react';
import { imagePath } from '../actions/ImagePath';
import { reactLocalStorage  } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import ApiGateway from "../DataServices/DataServices";
import { currencyFormatter , calculateSubTotal  } from "../DataServices/Utils";
import { UPDATE_INFO , UPDATE_CART , UPDATE_PRODUCT , UPDATE_NEW_PRODUCT , RESTORE } from '../actions/actionTypes';
import GBLVAR from "../Global Variables/GlobalVariables";
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Barcode  from 'react-barcode';
import cookie from "react-cookies";
class directSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transaction_data: JSON.parse(sessionStorage.getItem('transaction_data')),
            payment_response: JSON.parse(sessionStorage.getItem('payment_response')),
            order_details : {},
            loading : true,
        }       
        this.continueShipping = this.continueShipping.bind(this); 
    }
    componentDidMount(){  
        var _this=this;
        console.log(window.location.search);
        var getUrlParams = new URLSearchParams(window.location.search);
        //var urlParams = JSON.parse(getUrlParams.get('q'));
        console.log(getUrlParams);
        _this.setState({order_ref_no:getUrlParams.get('refid')}, () => {        
            // setTimeout(() => {
            //     var dataSuccess = {"status":"success","data": {"payment_status": "Transaction Success"}}
            //     console.log(dataSuccess);
            //     window.top.parent.postMessage(dataSuccess, "*")
            // }, 2000);
        });  
        ApiGateway.get(`https://api.foloosi.com/v1/customer/transaction-detail/${getUrlParams.get('transaction_no')}`,
		function (response) {
            console.log("response",response.data)
            _this.setState({order_details:response.data});  
        })
    }
    
    continueShipping(){
        //reactLocalStorage.clear();
        this.props.history.push("/");
        //window.location.reload();
    }
    render() {
        console.log(this.state.order_details);
        return (
            <div className="bg_wrapper">
                <ToastContainer />
                {this.state.order_details.service_type !== undefined ?
                    <div className="center_tab_thanks">  
                        <img  src={imagePath("./thankspage_vector.png").default} alt="" />
                        <p className="order_msg">Your order has been placed successfully. Thank You!</p>
                        <p className="order_msg">Order Id : <Link to={`/vieworder/${this.state.order_ref_no}`}> #{this.state.order_ref_no} </Link> </p>
                        {this.state.order_details.voucher_detail &&
                        <>
                        {this.state.order_details.service_type === 'voucher' ?
                        <div className="col-xs-12">
                            <div className="voucher_wrapper">
                                <div className="Voucher_details">Voucher Deatails</div>
                                <div className="inner_wrapr_voucher">
                                    <div className="half_vocher_wrap border_right">
                                        <div className="pincode_new">Pin Code</div>
                                        <span className="code_value">{this.state.order_details?.voucher_detail?.voucher?.pin_code}</span>
                                    </div>
                                    <div className="half_vocher_wrap">
                                        <div className="pincode_new">Bar Code</div>
                                        <span className="code_value ">
                                            <Barcode className="bar_code" value={this.state.order_details?.voucher_detail?.voucher?.bar_code} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="col-xs-12">
                            <div className="voucher_wrapper">
                                <div className="Voucher_details">Voucher Deatails</div>
                                <div className="inner_wrapr_voucher">
                                    <div className="half_vocher_wrap border_right">
                                        <div className="pincode_new">Product Name</div>
                                        <span className="code_value">{this.state.order_details?.like_card_detail?.serials["productName"]}</span>
                                    </div>
                                    <div className="half_vocher_wrap border_right">
                                        <span className="code_value"><img src={this.state.order_details?.like_card_detail?.serials["productImage"]}/></span>
                                    </div>
                                    <div className="half_vocher_wrap">
                                        <div className="pincode_new">Serial ID</div>
                                        <span className="code_value">{this.state.order_details?.like_card_detail?.serials["serialId"]}
                                        </span>
                                    </div>
                                    <div className="half_vocher_wrap">
                                        <div className="pincode_new">Serial Code</div>
                                        <span className="code_value">{this.state.order_details?.like_card_detail?.serials["serialCode"]}
                                        </span>
                                    </div>
                                    <div className="half_vocher_wrap">
                                        <div className="pincode_new">Serial Number</div>
                                        <span className="code_value">{this.state.order_details?.like_card_detail?.serials["serialNumber"]}
                                        </span>
                                    </div>
                                    <div className="half_vocher_wrap">
                                        <div className="pincode_new">Validity Upto</div>
                                        <span className="code_value">{this.state.order_details?.like_card_detail?.serials["validTo"]}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        </>
                        }
                        {/* <div className="thanks_con">Thank You</div> */}
                        <div className="thanks_con"><a className="continue_shopping" onClick={e=>this.continueShipping()}>Continue Shopping...</a></div>                        
                    </div>
                    :
                    <div className="center_tab_thanks">  
                        <img  src={imagePath("./thankspage_vector.png").default} alt="" />
                        <p className="order_msg">Your order has been placed successfully.</p>
                        <p className="order_msg">Order Id : <Link to={`/vieworder/${this.state.order_ref_no}`}> #{this.state.order_ref_no} </Link> </p>
                        <div className="thanks_con">Thank You</div>
                        <div className="thanks_con"><a className="continue_shopping" onClick={e=>this.continueShipping()}>Continue Shopping...</a></div>                        
                    </div>  
    }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      state: state.AppReducer
    }
};
  
const mapDispatchToProps = dispatch => ({
    update_store: (payload) => { dispatch({ type: UPDATE_INFO, payload }); return Promise.resolve(); },
    restoreBack :()=> dispatch({ type: RESTORE })
})
  
export default connect(mapStateToProps, mapDispatchToProps)(directSuccess);


